import { Stack, StackProps, SxProps } from '@mui/material';
import { ReactNode } from 'react';

import { SizingMultiplier } from '../sizing-multiplier.constant';

type HorizontalCarouselProps = {
  children: ReactNode;
  spacing?: StackProps['spacing'];
  edgeSpacing?: number;
  sx?: SxProps;
};

const DEFAULT_SPACING = 2;

export const HorizontalCarousel = ({
  spacing = DEFAULT_SPACING,
  edgeSpacing = SizingMultiplier.sm,
  sx,
  children,
}: HorizontalCarouselProps) => {
  return (
    <Stack
      direction="row"
      spacing={spacing}
      sx={{
        overflowX: 'auto',
        '::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar in Webkit browsers
        scrollbarWidth: 'none', // Hide scrollbar in Firefox
        msOverflowStyle: 'none', // Hide scrollbar in IE/Edge

        // needed for scrolling effect on mobile
        mr: (theme) => `-${theme.spacing(edgeSpacing)} !important`,
        pr: edgeSpacing,
        ml: (theme) => `-${theme.spacing(edgeSpacing)} !important`,
        pl: edgeSpacing,
        ...sx,
      }}>
      {children}
    </Stack>
  );
};
